import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    SET_IS_EXPANDED: createActionType(FULL_NAMESPACE, "SET_IS_EXPANDED"),
    SET_NAVIGATE_TO: createActionType(FULL_NAMESPACE, "SET_NAVIGATE_TO"),
    TOGGLE_METHOD_SELECTED: createActionType(FULL_NAMESPACE, "TOGGLE_METHOD_SELECTED"),
    CLEAR_METHODS_SELECTED: createActionType(FULL_NAMESPACE, "TOGGLE_CLEAR_SELECTED"),
    SET_TAB: createActionType(FULL_NAMESPACE, "SET_TAB"),
    SET_CONTENT_MODE_TAB: createActionType(FULL_NAMESPACE, "SET_CONTENT_MODE_TAB"),
    GET_DOCUMENTS: createActionType(FULL_NAMESPACE, "GET_DOCUMENTS"),
    GET_DOCUMENTS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_DOCUMENTS_COMPLETED"),
    GET_DOCUMENTS_REJECTED: createActionType(FULL_NAMESPACE, "GET_DOCUMENTS_REJECTED"),
    SET_OBJECTS_OUTDATED: createActionType(FULL_NAMESPACE, "SET_OBJECTS_OUTDATED"),
    SET_OBJECTS_USED_BY_UI: createActionType(FULL_NAMESPACE, "SET_OBJECTS_USED_BY_UI"),
    GET_OBJECTS: createActionType(FULL_NAMESPACE, "GET_OBJECTS"),
    GET_OBJECTS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_OBJECTS_COMPLETED"),
    GET_OBJECTS_REJECTED: createActionType(FULL_NAMESPACE, "GET_OBJECTS_REJECTED"),
    GET_METHODS: createActionType(FULL_NAMESPACE, "GET_METHODS"),
    GET_METHODS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_METHODS_COMPLETED"),
    GET_METHODS_REJECTED: createActionType(FULL_NAMESPACE, "GET_METHODS_REJECTED"),
    SET_DOCUMENT_SELECTED: createActionType(FULL_NAMESPACE, "SET_DOCUMENT_SELECTED"),
    SET_DOCUMENT_TYPE: createActionType(FULL_NAMESPACE, "SET_DOCUMENT_TYPE"),
    RUN_METHODS: createActionType(FULL_NAMESPACE, "RUN_METHODS"),
    RUN_METHODS_COMPLETED: createActionType(FULL_NAMESPACE, "RUN_METHODS_COMPLETED"),
    SET_SHOW_SCRIPT_EDITOR_PANEL: createActionType(FULL_NAMESPACE, "SET_SHOW_SCRIPT_EDITOR_PANEL"),
    SET_SCRIPT_DRAFT: createActionType(FULL_NAMESPACE, "SET_SCRIPT_DRAFT"),
    SAVE_SCRIPT: createActionType(FULL_NAMESPACE, "SAVE_SCRIPT"),
    SAVE_SCRIPT_COMPLETED: createActionType(FULL_NAMESPACE, "SAVE_SCRIPT_COMPLETED"),
    GET_SCRIPTS: createActionType(FULL_NAMESPACE, "GET_SCRIPTS"),
    GET_SCRIPTS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_SCRIPTS_COMPLETED"),
    GET_SCRIPTS_REJECTED: createActionType(FULL_NAMESPACE, "GET_SCRIPTS_REJECTED"),
    RUN_SCRIPT: createActionType(FULL_NAMESPACE, "RUN_SCRIPT"),
    RUN_SCRIPT_COMPLETED: createActionType(FULL_NAMESPACE, "RUN_SCRIPT_COMPLETED"),
    DELETE_SCRIPT: createActionType(FULL_NAMESPACE, "DELETE_SCRIPT"),
    DELETE_SCRIPT_COMPLETED: createActionType(FULL_NAMESPACE, "DELETE_SCRIPT_COMPLETED"),
    GET_TASKS: createActionType(FULL_NAMESPACE, "GET_TASKS"),
    GET_TASKS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_TASKS_COMPLETED"),
    GET_TASKS_REJECTED: createActionType(FULL_NAMESPACE, "GET_TASKS_REJECTED"),
    GET_REQUEST_TASK: createActionType(FULL_NAMESPACE, "GET_REQUEST_TASK"),
    GET_REQUEST_TASK_COMPLETED: createActionType(FULL_NAMESPACE, "GET_REQUEST_TASK_COMPLETED"),
    GET_REQUEST_TASK_REJECTED: createActionType(FULL_NAMESPACE, "GET_REQUEST_TASK_REJECTED"),
    STOP_REQUEST_TASK: createActionType(FULL_NAMESPACE, "STOP_REQUEST_TASK"),
    STOP_REQUEST_TASK_COMPLETED: createActionType(FULL_NAMESPACE, "STOP_REQUEST_TASK_COMPLETED"),
    STOP_REQUEST_TASK_REJECTED: createActionType(FULL_NAMESPACE, "STOP_REQUEST_TASK_REJECTED"),
    RESTART_REQUEST_TASK: createActionType(FULL_NAMESPACE, "RESTART_REQUEST_TASK"),
    RESTART_REQUEST_TASK_COMPLETED: createActionType(FULL_NAMESPACE, "RESTART_REQUEST_TASK_COMPLETED"),
    RESTART_REQUEST_TASK_REJECTED: createActionType(FULL_NAMESPACE, "RESTART_REQUEST_TASK_REJECTED"),
    SET_REQUEST_TASK_OUTDATED: createActionType(FULL_NAMESPACE, "SET_REQUEST_TASK_OUTDATED"),
    SET_SOURCE_TASK_IDS_TO_HIGHLIGHT: createActionType(FULL_NAMESPACE, "SET_SOURCE_TASK_IDS_TO_HIGHLIGHT"),
    CLEAR_SOURCE_TASK_IDS_TO_HIGHLIGHT: createActionType(FULL_NAMESPACE, "CLEAR_SOURCE_TASK_IDS_TO_HIGHLIGHT")
};
